// extracted by mini-css-extract-plugin
module.exports = {"column":"Offer-module_column_1GVvd","empty":"Offer-module_empty_ZvxHz","form":"Offer-module_form_3zpOi"};